import { render, staticRenderFns } from "./dueDateEditModal.vue?vue&type=template&id=42fdf867&scoped=true&"
import script from "./dueDateEditModal.vue?vue&type=script&lang=js&"
export * from "./dueDateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fdf867",
  null
  
)

export default component.exports